export default __webpack_public_path__ + "static/media/red-headphone.cff4ab43.png";